import { z } from "zod";

export const serviceOptionSchema = z.object({
  id: z.string().optional(),
  optionName: z.string().min(1, "Option name is required"),
  priceModifier: z.number(),
  durationModifier: z.number(),
  isDefault: z.boolean(),
  sortOrder: z.number().min(0),
});

export const serviceOptionGroupSchema = z
  .object({
    id: z.string().optional(),
    name: z.string().min(1, "Option group name is required"),
    selectionType: z.union([z.literal("SINGLE"), z.literal("MULTIPLE")]),
    minSelections: z.number().min(0),
    maxSelections: z.number().min(1).nullable().optional(),
    sortOrder: z.number().min(0),
    options: z.array(serviceOptionSchema),
  })
  .refine((data) => data.options.length > 0, {
    message: "At least one option is required",
    path: ["options"],
  });

export const serviceEditSchema = z.object({
  templateId: z.string().nullable().optional(), // null = custom config, string = template reference
  basicInfo: z.object({
    name: z.string().min(1, "Service name is required"),
    description: z.string().optional(),
    categoryId: z.string().optional(),
    serviceCode: z.string().min(1, "Service code is required"),
    duration: z.number().min(0, "Duration cannot be negative"),
    isActive: z.boolean(),
    allowOnlineBooking: z.boolean(),
    storefrontDisplayMode: z.enum(["TABLE", "REGULAR"]).nullable().optional(),
    isPopular: z.boolean(),
  }),
  pricing: z.object({
    pricingMode: z.union([
      z.literal("NO_PRICE"),
      z.literal("SINGLE_PRICE"),
      z.literal("MATRIX_PRICE"),
    ]),
    basePrice: z.number().min(0, "Base price cannot be negative"),
  }),
  optionGroups: z.array(serviceOptionGroupSchema),
});

export type ServiceEditFormData = z.infer<typeof serviceEditSchema>;
